import generateSchema from 'generate-schema';
import { JSONSchema7 } from 'json-schema';

export function generateSchemaFromObj(
  obj: Record<string, unknown>,
  makeOptional = true
): JSONSchema7 | undefined {
  try {
    const schema = generateSchema.json('JSONSchema', obj);

    // Remove all required fields from the schema

    if (makeOptional) {
      makePropertiesOptional(schema);
    }
    return schema;
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

function makePropertiesOptional(schemaObj) {
  // Delete the required array if it exists
  delete schemaObj.required;

  // Recursively process nested objects
  if (schemaObj.properties) {
    Object.values(schemaObj.properties).forEach((prop) => {
      if (typeof prop === 'object') {
        makePropertiesOptional(prop);
      }
    });
  }

  // Handle arrays with items that might be objects
  if (schemaObj.items && typeof schemaObj.items === 'object') {
    makePropertiesOptional(schemaObj.items);
  }
}
